import React from 'react';
import './index.less';

const Banner = ({bannerBg, title, description}) => (
  <div className='new-mobile-banner'>
    <div
      className='banner-image'
    >
      <img src={bannerBg} alt='banner' />
      {/* <img src={BannerLeft} alt='banner-left' object-fit='cover' />
      <img src={BannerRight} alt='banner-right' object-fit='cover' /> */}
    </div>
    <div className='banner-content'>
      <div className='title'>
        <span>{title}</span>
      </div>
      <div className='description'>
        {description}
      </div>
    </div>
  </div>
);

export default Banner;
